/* HH 2026-10-18 — cart drawer suggestions loader (sections/hh-cart-recs; R2 2026-10-19: title + products follow the room of the cart's main piece).
   The theme re-renders the drawer items on every cart change, so this element is created again each time; results are cached
   per first product + cart contents, so the request only repeats when the cart actually changed. Fails quietly (no block). */
(() => {
  if (customElements.get('hh-cart-recs')) return;
  const cache = new Map();
  class HHCartRecs extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url || '';
      if (!/product_id=\d+/.test(url)) return;
      const key = url + '|' + (this.dataset.key || '');
      if (cache.has(key)) { this.fill(cache.get(key)); return; }
      fetch(url, { credentials: 'same-origin' })
        .then(r => (r.ok ? r.text() : ''))
        .then(text => {
          let html = '';
          if (text) {
            const inner = new DOMParser().parseFromString(text, 'text/html').querySelector('.hh-cart-recs__inner');
            html = inner ? inner.innerHTML.trim() : '';
          }
          cache.set(key, html);
          if (this.isConnected) this.fill(html);
        })
        .catch(() => {});
    }
    fill(html) {
      this.innerHTML = html;
      this.toggleAttribute('data-filled', html.length > 0);
    }
  }
  customElements.define('hh-cart-recs', HHCartRecs);
})();
